<div class="container" style="--rating: {{ rating.toFixed(1) }}">
  <div class="rating" [style.width.%]="rating * 20"></div>
  <div class="empty"></div>
  <div>
    <div>
      <span>
        @if (!starOnly) {
          <span>{{rating?.toFixed(1)}} (<span class="reviews">{{reviews}}</span>Reviews)</span>
        }
      </span>
    </div>
